////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////
/*global google*/
import React, { Component } from 'react';
import axios from 'axios'

import redtowericon from './redtower.png'

class TddFormPage extends Component {
  constructor(props) {
    super(props);

    const stationToEdit = this.props.existingStations[this.props.stationIndex];

    this.state = {
      locationentry: "map",
      latitude: stationToEdit.lat,
      longitude: stationToEdit.long,
      address: stationToEdit.address,
      eastings: stationToEdit.eastings,
      northings: stationToEdit.northings,
      britgrid: stationToEdit.britgrid,
      address_components: stationToEdit.address_components,
      sectors: stationToEdit.sectors
    };

    google.maps.event.clearListeners(this.props.map, "click");
    google.maps.event.addListener(this.props.map, 'click', e => {
      this.state.latitude = +e.latLng.lat().toFixed(5);
      this.state.longitude = +e.latLng.lng().toFixed(5);
      this.placeSiteMarker(e.latLng.lat(), e.latLng.lng())
      this.convertCoordinates({gps:{lat:this.state.latitude, lng:this.state.longitude}},["latitude","longitude"])
    });
  }

  componentWillUnmount() {
    if (this.newSiteMarker){
      this.newSiteMarker.setMap(null)
    }
    google.maps.event.clearListeners(this.props.map, "click");
    this.props.onCancel();
  }

  renderError = ({ meta: { touched, error } }) =>
    touched && 
    error ? <span>{error}</span> : false


  reverseGeocode(lat,lng) {
    if (lat<-90 || lat>90 || lng<-180 || lng>180) {
        return
    }

    let URL = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${localStorage.getItem("google_maps_api_key")}`
    axios.get(URL, { withCredentials: false })
    .then(response => {
      this.setState({
        address: response.data.results[0]["formatted_address"],
        address_components: response.data.results[0]["address_components"]
      })
    })
    .catch(error => {
      console.log(error)
    })
  }
  
  geocode(address) {
    let URL = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${localStorage.getItem("google_maps_api_key")}`
    axios.get(URL, { withCredentials: false })
    .then(response => {
      if (response.data.results.length>0){
        this.state.latitude = +response.data.results[0].geometry.location.lat.toFixed(5);
        this.state.longitude = +response.data.results[0].geometry.location.lng.toFixed(5);
        this.convertCoordinates({gps:{lat:this.state.latitude, lng:this.state.longitude}},["latitude","longitude", "address"], this.placeSiteMarker)
      }
    })
    .catch(error => {
      console.log(error)
      this.setState({})
    })
  }

  convertCoordinates(coords, changedFields, callback) {
    let URL = `${this.props.SERVER_URLS.api}/national_grid_conversions`
    const config = { headers: { 'content-type': 'application/json' } }

    const _this = this;

    axios.put(URL, coords, config)
    .then(response => {
        let stateUpdate = {
            latitude: +response.data.gps.lat.toFixed(5),
            longitude: +response.data.gps.lng.toFixed(5),
            eastings: +response.data.osgb36[0].toFixed(0),
            northings: +response.data.osgb36[1].toFixed(0),
            britgrid: response.data.bng
        }

        _this.setState(stateUpdate)
        if (callback)
          callback(response.data.gps.lat, response.data.gps.lng);

        if (!changedFields.includes("address"))
          this.reverseGeocode(response.data.gps.lat, response.data.gps.lng)
    })
    .catch(error => {
        console.log(error);
        let stateUpdate = {
            latitude: null,
            longitude: null,
            eastings: null,
            northings: null,
            britgrid: null,
        }
        for (let key of changedFields) {
            delete stateUpdate[key];
        }
        _this.setState(stateUpdate)
    })
  }

  handleInput(fieldname) {
    return (event) =>{

      if (fieldname==="address" || fieldname==="britgrid") {
        this.setState({[fieldname]: event.target.value});
      } else if (fieldname==="eastings" || fieldname==="northings") {
        this.setState({[fieldname]: +parseFloat(event.target.value).toFixed(0)});
      } else if (fieldname==="latitude" || fieldname==="longitude") {
        this.setState({[fieldname]: +parseFloat(event.target.value).toFixed(5)});
      }
    }
  }
  
  handleCompletedInput(fieldname) {
    return (event) =>{

      if (fieldname==="address"){
        this.geocode(this.state.address)
      } else if (fieldname==="eastings" || fieldname==="northings") {
        if (this.state.northings && this.state.eastings) {
          this.convertCoordinates({osgb36: [this.state.eastings, this.state.northings]}, ["eastings", "northings"], this.placeSiteMarker)
        }
      } else if (fieldname==="britgrid") {
        this.convertCoordinates({bng:this.state.britgrid},["britgrid"], this.placeSiteMarker);
      } else if (fieldname==="latitude" || fieldname==="longitude") {
        if (this.state.longitude && this.state.latitude) {
          this.placeSiteMarker(this.state.latitude, this.state.longitude); // do this here instead of in callback for responsiveness
          this.convertCoordinates({gps: {lat: this.state.latitude, lng: this.state.longitude}}, ["latitude", "longitude"]);
        }
      }
    }
  }

  placeSiteMarker = (lat,long) => {
    if (this.newSiteMarker){
      this.newSiteMarker.setMap(null)
    }
    this.newSiteMarker = new google.maps.Marker({
      position: {
        lat: lat,
        lng: long,
      },
      map: this.props.map,
      icon: redtowericon
    });

    if (!this.props.map.getBounds().contains(this.newSiteMarker.getPosition())) {
      this.props.map.setCenter(this.newSiteMarker.getPosition())
    }
  }

  handleSubmit() {
    if (this.newSiteMarker){
      this.newSiteMarker.setMap(null)
    }
    this.props.submitAddStation(this.state, this.props.stationIndex);
  }

  render(){
    return (
      <React.Fragment>
        <form>
        <div className="row">
            <b>Location entry method:&nbsp;</b>
            <select value={this.state.locationentry} onChange={(e)=>this.setState({locationentry: e.target.value})}>
                <option value="map">Enter location by selecting a point on the map</option>
                <option value="latlong">GPS coordinates(latitude/longitude)</option>
                <option value="osgb36">OSGB36 coordinates(eastings/northings)</option>
                <option value="britgrid">Alphanumeric British Grid reference</option>
                <option value="address">Enter location by street address</option>
            </select>
        </div>
        <br/>
          <div className="row">
            <div className="col">
              <div>
                <label>Latitude</label>
                <input disabled={this.state.locationentry!="latlong"} type="number" value={this.state.latitude} onChange={this.handleInput("latitude")} onBlur={this.handleCompletedInput("latitude")}/>
              </div>
            </div>
            <div className="col">
              <div>
                <label>Longitude</label>
                <input disabled={this.state.locationentry!="latlong"} type="number" value={this.state.longitude} onChange={this.handleInput("longitude")} onBlur={this.handleCompletedInput("longitude")} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div>
                <label>Easting</label>
                <input disabled={this.state.locationentry!="osgb36"} type="number" value={this.state.eastings} onChange={this.handleInput("eastings")} onBlur={this.handleCompletedInput("eastings")} />
              </div>
            </div>
            <div className="col">
              <div>
                <label>Northing</label>
                <input disabled={this.state.locationentry!="osgb36"} type="number" value={this.state.northings} onChange={this.handleInput("northings")} onBlur={this.handleCompletedInput("northings")} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div>
                <label>Grid Ref.</label>
                <input disabled={this.state.locationentry!="britgrid"} type="text" value={this.state.britgrid} onChange={this.handleInput("britgrid")} onBlur={this.handleCompletedInput("britgrid")} />
              </div>
            </div>
            <div className="col">
              <div>
                <label>Address</label>
                <input disabled={this.state.locationentry!="address"} type="text" value={this.state.address} onChange={this.handleInput("address")} onBlur={this.handleCompletedInput("address")} />
              </div>
            </div>
          </div>
          <p>After entering location via selected entry method, click out of field to auto-resolve other values</p>

          <div className="button-row">
            <button type="button" className="btn btn-danger" disabled={false} onClick={()=>this.props.removeStation()}> Delete Site</button>
            <button type="button"
                    className="btn btn-light"
                    disabled={false}
                    onClick={()=>this.props.onCancel()}>
              Discard Changes
            </button>
            <button type="button"
                    className="btn btn-primary"
                    disabled={(()=>{
                        for (let field of ["latitude","longitude","eastings","northings"]){
                            if (isNaN(this.state[field])){
                                return true
                            }
                        }
                        for (let field of ["address","britgrid"]){
                            if (!this.state[field] || this.state[field].length<1){
                                return true
                            }
                        }
                        return false               
                    })()}
                    onClick={()=>this.handleSubmit()}>
              Apply
            </button>
          </div>
        </form>
      </React.Fragment>
    );
  };

}

export default TddFormPage



